export const casts = [
  {
    id: "c1",
    name: "林晚",
    initial: "L",
    role: "苏念",
    roleType: "主角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20gentle%20young%20Chinese%20woman%20in%20her%20early%20thirties%20with%20soft%20natural%20makeup%2C%20warm%20cream%20studio%20background%2C%20cinematic%20drama%20character%20portrait%2C%20soft%20window%20light%2C%20terracotta%20accents&width=600&height=600&seq=cast-01&orientation=squarish",
    roleIntro:
      "苏念，三十岁的新手母亲，曾经的设计师。她在家庭与自我之间反复拉扯，最终学会与自己和解。",
    bio: [
      "林晚在剧中饰演女主角苏念，这是她首次挑战母亲题材。为了贴近角色，她提前两个月跟随新手妈妈体验生活。",
      "她把苏念的疲惫、倔强与柔软拿捏得恰到好处，被观众称为“最真实的年轻母亲”。",
      "代表作品包括家庭剧《归途》《晚风信箱》等，以细腻内敛的表演风格著称。",
    ],
    storyIds: ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9", "s10", "s11", "s12", "s13"],
  },
  {
    id: "c2",
    name: "陈知远",
    initial: "C",
    role: "江辰",
    roleType: "主角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20calm%20Chinese%20man%20in%20his%20mid%20thirties%20wearing%20a%20simple%20shirt%2C%20warm%20beige%20studio%20background%2C%20cinematic%20drama%20character%20portrait%2C%20soft%20lighting%2C%20muted%20clay%20tones&width=600&height=600&seq=cast-02&orientation=squarish",
    roleIntro: "江辰，苏念的丈夫，理性而迟钝的工程师。他在一次次冲突中学会承担，也逐渐读懂妻子的沉默。",
    bio: [
      "陈知远饰演的江辰是全剧争议最大的角色，他不完美，却足够真实。",
      "他用克制的表演呈现了一个普通丈夫的成长轨迹，从“和稀泥”到真正站出来。",
      "此前多出演都市情感题材，被观众称为“最会演普通人的实力派”。",
    ],
    storyIds: ["s1", "s3", "s6", "s8", "s10", "s12"],
  },
  {
    id: "c3",
    name: "何淑芬",
    initial: "H",
    role: "苏念母亲",
    roleType: "主角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20Chinese%20woman%20in%20her%20late%20fifties%20with%20gentle%20smile%2C%20soft%20cream%20studio%20background%2C%20cinematic%20drama%20character%20portrait%2C%20warm%20natural%20light%2C%20earthy%20terracotta%20tones&width=600&height=600&seq=cast-03&orientation=squarish",
    roleIntro: "何淑芬，苏念的母亲。她话不多，却总在最需要的时候出现，是女儿最坚实的依靠。",
    bio: [
      "何淑芬饰演的苏母是全剧的定海神针，一个眼神就能让人安心。",
      "她把老一辈母亲不善表达却深沉的爱演绎得丝丝入扣，贡献了多场催泪名场面。",
      "从艺三十余年，塑造过无数经典母亲形象，被誉为“国民母亲”。",
    ],
    storyIds: ["s1", "s2", "s4", "s9", "s13"],
  },
  {
    id: "c4",
    name: "江小满",
    initial: "J",
    role: "小满",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cheerful%20young%20Chinese%20girl%20around%20six%20years%20old%20with%20short%20hair%2C%20warm%20soft%20studio%20background%2C%20cinematic%20family%20drama%20portrait%2C%20bright%20natural%20light&width=600&height=600&seq=cast-04&orientation=squarish",
    roleIntro: "小满，苏念与江辰的女儿。她天真好动，一句“妈妈”就能化解大人所有的疲惫。",
    bio: [
      "小演员江小满在剧中饰演女儿的童年阶段，灵气十足，是剧组公认的开心果。",
      "她那场夜里发烧的哭戏一条过，感染了现场所有工作人员。",
      "这是她的第二部影视作品，却已经展现出超越年龄的镜头感。",
    ],
    storyIds: ["s1", "s3", "s10", "s12", "s13"],
  },
  {
    id: "c5",
    name: "周予安",
    initial: "Z",
    role: "沈予安",
    roleType: "主角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20thoughtful%20Chinese%20man%20in%20his%20early%20thirties%20with%20a%20gentle%20expression%2C%20warm%20taupe%20studio%20background%2C%20cinematic%20drama%20character%20portrait%2C%20soft%20directional%20light&width=600&height=600&seq=cast-05&orientation=squarish",
    roleIntro: "沈予安，苏念的旧友，也是她青春里的一段遗憾。他的出现，让苏念不得不面对过去与现在的自己。",
    bio: [
      "周予安饰演的沈予安克制而温柔，是许多观众心中的“意难平”。",
      "他在雨夜和解那场戏中的表演被评价为“成全式的深情”。",
      "以文艺片出道，近年来尝试更多现实题材角色。",
    ],
    storyIds: ["s5", "s11"],
  },
  {
    id: "c6",
    name: "陆行舟",
    initial: "L",
    role: "陆医生",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20reassuring%20Chinese%20male%20doctor%20in%20his%20forties%20wearing%20a%20white%20coat%2C%20clean%20warm%20grey%20studio%20background%2C%20cinematic%20drama%20portrait%2C%20soft%20clinical%20light&width=600&height=600&seq=cast-06&orientation=squarish",
    roleIntro: "陆医生，急诊科医生。他冷静专业，在关键时刻给了苏念一家定心的力量。",
    bio: [
      "陆行舟饰演的陆医生戏份不多，却是剧中重要的“稳定器”。",
      "为了演好医生，他到医院跟诊学习了两周。",
      "擅长塑造沉稳可靠的职业形象。",
    ],
    storyIds: ["s4", "s8"],
  },
  {
    id: "c7",
    name: "苏晴",
    initial: "S",
    role: "苏晴",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20lively%20young%20Chinese%20woman%20in%20her%20late%20twenties%20with%20a%20bright%20smile%2C%20soft%20peach%20studio%20background%2C%20cinematic%20drama%20portrait%2C%20warm%20natural%20light&width=600&height=600&seq=cast-07&orientation=squarish",
    roleIntro: "苏晴，苏念的妹妹。她活泼直率，常常用最直接的方式点醒固执的姐姐。",
    bio: [
      "苏晴饰演的妹妹是全剧的“气氛担当”，负责在沉重之余带来笑声。",
      "她的台词节奏轻快，被剪成多个短视频热传。",
      "近年活跃于都市轻喜剧领域。",
    ],
    storyIds: ["s2", "s9"],
  },
  {
    id: "c8",
    name: "顾南枝",
    initial: "G",
    role: "顾南枝",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20capable%20Chinese%20professional%20woman%20in%20her%20thirties%20wearing%20a%20blazer%2C%20warm%20neutral%20studio%20background%2C%20cinematic%20drama%20portrait%2C%20soft%20business%20lighting&width=600&height=600&seq=cast-08&orientation=squarish",
    roleIntro: "顾南枝，苏念的职场挚友与同事。她干练通透，是苏念重返职场后最信任的伙伴。",
    bio: [
      "顾南枝饰演的职场女性清醒又仗义，说出了许多观众的心声。",
      "她与苏念之间的“姐妹情”成为剧中另一条温暖的支线。",
      "兼具话剧与影视经验，台词功底扎实。",
    ],
    storyIds: ["s2", "s7", "s12"],
  },
  {
    id: "c9",
    name: "老郑",
    initial: "L",
    role: "郑伯",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20kind%20elderly%20Chinese%20man%20in%20his%20sixties%20with%20grey%20hair%2C%20warm%20brown%20studio%20background%2C%20cinematic%20drama%20portrait%2C%20soft%20window%20light&width=600&height=600&seq=cast-09&orientation=squarish",
    roleIntro: "郑伯，社区里的老邻居。他见证了几代人的故事，总爱说一句“日子嘛，慢慢过”。",
    bio: [
      "老郑饰演的郑伯是社区的“活地图”，也是剧中许多重要转折的见证者。",
      "一句朴素台词常常让观众红了眼眶。",
      "从艺四十余年，是剧组年轻演员敬重的老戏骨。",
    ],
    storyIds: ["s9", "s13"],
  },
  {
    id: "c10",
    name: "白露",
    initial: "B",
    role: "白露",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20an%20elegant%20young%20Chinese%20woman%20in%20her%20late%20twenties%20with%20long%20hair%2C%20soft%20rose%20studio%20background%2C%20cinematic%20drama%20portrait%2C%20gentle%20natural%20light&width=600&height=600&seq=cast-10&orientation=squarish",
    roleIntro: "白露，苏念在社区活动中认识的朋友。她也曾是一位母亲，用自己的经历给了苏念很多力量。",
    bio: [
      "白露饰演的角色安静而有力量，是苏念走出低谷的重要陪伴者。",
      "两人在活动室的一场长谈成为全剧被反复回味的片段。",
      "擅长塑造有故事感的女性角色。",
    ],
    storyIds: ["s12", "s9"],
  },
  {
    id: "c11",
    name: "程屿",
    initial: "C",
    role: "程屿",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20office%20worker%20man%20in%20his%20late%20twenties%2C%20warm%20grey%20studio%20background%2C%20cinematic%20drama%20portrait%2C%20soft%20daylight%2C%20restrained%20expression&width=600&height=600&seq=cast-11&orientation=squarish",
    roleIntro: "程屿，苏念的同事。一次项目误会让他与苏念产生嫌隙，最终也在合作中学会了彼此尊重。",
    bio: [
      "程屿饰演的年轻同事代表了职场中常见的沟通困境。",
      "他的转变让“被误解的善意”这一集有了更完整的落点。",
      "电影学院毕业后首次出演电视剧重要配角。",
    ],
    storyIds: ["s7"],
  },
  {
    id: "c12",
    name: "秦妈妈",
    initial: "Q",
    role: "秦姨",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20traditional%20Chinese%20grandmother%20in%20her%20early%20sixties%20with%20grey%20bun%2C%20warm%20beige%20studio%20background%2C%20cinematic%20drama%20portrait%2C%20soft%20light%2C%20dignified%20expression&width=600&height=600&seq=cast-12&orientation=squarish",
    roleIntro: "秦姨，江辰的母亲。她传统要强，与儿媳苏念冲突不断，却也在相处中慢慢学会放手。",
    bio: [
      "秦妈妈饰演的婆婆立体可信，不是脸谱化的“恶婆婆”。",
      "她与苏念的对手戏真实到让许多观众直呼“看到了自己家”。",
      "资深舞台剧演员，台词与节奏控制精准。",
    ],
    storyIds: ["s3", "s8"],
  },
  {
    id: "c13",
    name: "果果",
    initial: "G",
    role: "幼年苏念",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20sweet%20young%20Chinese%20girl%20around%20eight%20years%20old%20with%20braided%20hair%2C%20soft%20cream%20studio%20background%2C%20cinematic%20drama%20portrait%2C%20warm%20gentle%20light&width=600&height=600&seq=cast-13&orientation=squarish",
    roleIntro: "果果饰演回忆线中的幼年苏念，出现在母亲的老照片与过往片段里。",
    bio: [
      "小演员果果在回忆戏中贡献了极为真诚的表演。",
      "她的一场哭戏让现场工作人员集体“破防”。",
      "这是她的第一部电视剧作品。",
    ],
    storyIds: ["s9", "s13"],
  },
];